import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { pathOr } from "ramda";
import styled, { ThemeContext } from "styled-components";
import { typography } from "styled-system";

// ------------------------------------------------------------------------
import { Checkbox } from "@sisuwellness/ui/src/components/Forms";
import Flex from "components/Flex";

import { CheckboxLabel } from "../styled";
import { useTranslation } from "react-i18next";
import { NameField } from "components/Forms";

// ------------------------------------------------------------------------

const CustomLink = styled.a`
    color: ${props => props.theme.colours.blackTints700.hex};
    ${typography}
`;

// ------------------------------------------------------------------------

const RegisterTNC = ({ consents, onChange, ...rest }) => {
    const { t } = useTranslation();
    const theme = useContext(ThemeContext);

    const defaultCheckboxState = {};
    consents.forEach((_, index) => (defaultCheckboxState[`checkbox-${index}`] = false));

    const [checkboxState, setCheckboxState] = useState(defaultCheckboxState);

    useEffect(() => {
        const tncState = Object.values(checkboxState).reduce((acc, current) => acc && current, true);
        onChange(tncState);
    }, [checkboxState]);

    const handleOnChange = event => {
        setCheckboxState({ ...checkboxState, [event.target.id]: event.target.checked });
    };

    const termsAndConditionsUK = (
        <CustomLink target="_blank" rel="noopener noreferrer" href="https://sisuhealth.co.uk/terms-use-uk/">
            {t("members_portal_web.views.sign_up.register.terms_of_use", "Terms of Use")} (UK)
        </CustomLink>
    );

    const termsAndConditionsEU = (
        <CustomLink target="_blank" rel="noopener noreferrer" href="https://sisuhealth.co.uk/terms-use-eu/">
            {t("members_portal_web.views.sign_up.register.terms_of_use", "Terms of Use")} (EU)
        </CustomLink>
    );

    const privacyPolicyUK = (
        <CustomLink target="_blank" rel="noopener noreferrer" href="https://sisuhealth.co.uk/privacy-policy-uk/">
            {t("members_portal_web.views.sign_up.register.privacy_policy", "Privacy Policy")} (UK)
        </CustomLink>
    );

    const privacyPolicyEU = (
        <CustomLink target="_blank" rel="noopener noreferrer" href="https://sisuhealth.co.uk/privacy-policy-eu/">
            {t("members_portal_web.views.sign_up.register.privacy_policy", "Privacy Policy")} (EU)
        </CustomLink>
    );

    return (
        <>
            <Flex fd="column" onChange={handleOnChange} gap="15px" {...rest}>
                {consents.map((item, index) => {
                    let label = pathOr(null, ["configuration", "plaintext", "text"], item);
                    return (
                        <Checkbox id={index} color={theme.colours.hpGreen.hex} key={index}>
                            <CheckboxLabel fontSize={["13px", "16px"]}>{t(label)}</CheckboxLabel>
                        </Checkbox>
                    );
                })}
            </Flex>
            <Flex fd="column" width="100%" gap="0px" mt="0px">
                <Flex gap={["10px", "5px"]} fd={["column", "row"]}>
                    {termsAndConditionsUK}&nbsp;&nbsp;&nbsp;
                    {termsAndConditionsEU}&nbsp;&nbsp;&nbsp;
                    {privacyPolicyUK}&nbsp;&nbsp;&nbsp;
                    {privacyPolicyEU}
                </Flex>
            </Flex>
        </>
    );
};

RegisterTNC.propTypes = {
    ...Flex.propTypes,
    consents: PropTypes.array,
    onChange: PropTypes.func
};

export default RegisterTNC;
